import React, { FC } from "react";
import { useParams } from "react-router-dom";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";

import { BusinessDivisionEditForm } from "./components/BusinessDivisionEditForm";

export const ManagersBusinessDivisionsEdit: FC = () => {
  const { id = "" } = useParams<{ id: string }>();

  const breadCrumbItems = [
    { label: "部署設定", href: "/managers/business_divisions" },
    { label: "編集", href: `/managers/business_divisions/${id}/edit` },
  ];

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar>
        <BusinessDivisionEditForm businessDivisionId={id} />
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
